var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.591,
    height: 33.591,
    viewBox: "0 0 33.591 33.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_878",
    "data-name": "Group 878",
    transform: "translate(-413.177 -58.62)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_878-2",
    "data-name": "Group 878",
    transform: "translate(413.177 58.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M429.973,58.62a16.8,16.8,0,1,1-16.8,16.8,16.8,16.8,0,0,1,16.8-16.8",
    transform: "translate(-413.177 -58.62)",
    fill: "#53ae94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M439.917,83.017v-2.5h5.714V76.712H430.073v3.807h5.714v2.5c-4.644.213-8.136,1.133-8.136,2.235s3.494,2.022,8.136,2.236v8h4.132v-8c4.636-.214,8.12-1.133,8.12-2.234s-3.484-2.02-8.12-2.234m0,3.79v0c-.116.007-.715.043-2.049.043-1.066,0-1.816-.031-2.081-.044v0c-4.1-.182-7.166-.9-7.166-1.751s3.063-1.569,7.166-1.751V86.1c.269.019,1.037.064,2.1.064,1.274,0,1.915-.053,2.033-.064v-2.79c4.095.182,7.15.9,7.15,1.75s-3.057,1.567-7.15,1.75",
    transform: "translate(-421.049 -68.459)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.042a86046e35866358eef9019ae8a578.svg";
export { ForwardRef as ReactComponent };